module.exports = __webpack_public_path__ + "media/endOfGame.df71d714.mp3";